import React from 'react';
import PropTypes from 'prop-types';
import { HeroPropType } from '@/components/HeaderHero/util/heroPropType';
import { HeaderHero } from '@/components/HeaderHero';
import { useBrand } from '@bnnvara/brand';
import * as S from './styled';
import BrandHub from '../BrandHub/BrandHub';

const Header = ({ headerData }) => {
  const brand = useBrand();

  return (
    <>
      <S.HeaderBase id="header">
        <HeaderHero header={headerData} />
      </S.HeaderBase>
      <BrandHub data={brand || headerData.page} />
    </>
  );
};

Header.propTypes = {
  headerData: PropTypes.shape({
    header: PropTypes.shape({
      hero: PropTypes.arrayOf(HeroPropType),
    }),
    page: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      logoUrl: PropTypes.string,
    }),
  }),
};

export default Header;
